<template>
    <div class="search-area">
        <div  style="padding:8px 0px; display: flex;align-items: center; ">

           <el-form class="demo-form-inline" style="width:100%;">
                <div style="width:100%;display:flex;align-items: center;">
                    <div style="width:70%;display:flex;align-items: center; justify-content: flex-start; ">
                      
                      <div class="input-group" style="width: 260px;" :class="{ 'has-value': searchParam.level !== '' }">
                            <el-select
                              v-model="searchParam.level" 
                              id="level"
                              class="select-field"
                              style="width:260px;"
                              clearable
                              placeholder=" "
                            >
                              <el-option
                                v-for="item in levelOpt"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              >
                              </el-option>
                            </el-select>
                            <label for="level" class="floating-label1" style="border:0px;">城市级别</label>
                        </div>

                        <div class="input-group-search">
                          <el-input type="text" id="cityName" v-model="searchParam.cityName" class="input-field" clearable style="width:260px;" placeholder=" " />
                          <label for="cityName" class="floating-label">城市名称</label>
                        </div>

                    </div>
                    <div style="width:30%;text-align:right; font-size: 24px; cursor: pointer;">

                        <el-tooltip class="item" effect="dark"  content="新增" placement="bottom">
                            <i class="el-icon-plus" @click="addOpenDrawer" ></i>
                        </el-tooltip>

                        <el-tooltip class="item" effect="dark"  content="刷新" placement="bottom">
                            <i class="el-icon-refresh" @click="getPage" ></i>
                        </el-tooltip>

                    </div>

                </div>

            </el-form>

        </div>


       <el-table class="table-data" :data="tableData" :height="tableHeight"  style="width:100%; margin-bottom: 10px; ">

          <el-table-column
                prop="id"
                label="城市id"
                style="width:150">
         </el-table-column>
         <el-table-column
                prop="cityName"
                label="城市名"
                style="width:150">
         </el-table-column>
         <el-table-column
                prop="parentId"
                label="父类城市Id"
                style="width:150">
         </el-table-column>
         <el-table-column
                prop="shortName"
                label="简写名称"
                style="width:150">
         </el-table-column>
         <el-table-column
                prop="lng"
                label="经度"
                style="width:150">
         </el-table-column>
         <el-table-column
                prop="lat"
                label="纬度"
                style="width:150">
         </el-table-column>
         <el-table-column
                prop="level"
                label="城市级别"
                style="width:150">
         </el-table-column>
         <el-table-column
                prop="sort"
                label="排序"
                style="width:150">
         </el-table-column>

            <el-table-column
                    label="操作"
                    fixed="right"
                    width="200"
                    >
                <template slot-scope="scope">
                    <el-tooltip class="item table-btn-icon" effect="dark" content="查看详情" placement="bottom">
                        <i class="el-icon-edit table-icon" @click="getId(scope.row)"></i>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                @next-click="nextClick"
                @prev-click="prevClick"
                :current-page="pageUtil.curPage"
                :page-sizes="[20, 30, 50, 100,200]"
                :page-size="pageUtil.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageUtil.total"
                style="height: 30px; line-height: 30px; margin:10px auto; text-align: center;">
        </el-pagination>

        <el-drawer
          title="编辑"
          :visible.sync="isOpenDrawer"
          :wrapperClosable="false"
          direction="rtl"
          :before-close="handleClose">
           <!-- 使用flex布局确保底部固定 -->
          <div class="drawer-container">
            <!-- 可滚动的内容区域 -->
            <div class="drawer-content">
              <!-- <span>我来啦!</span> -->
              <!-- 这里可以放置您的表单或其他内容 -->
              <!-- <div style="height: 1500px; background: #f5f5f5; margin-top: 20px;">
                模拟长内容区域
              </div> -->

              <el-form  ref="loginForm" >


              <div class="input-group" >
               <el-form-item prop="id" >
                    <el-input type="text" id="id" v-model="city.id" class="input-field" placeholder=" " />
                     <label for="id" class="floating-label">城市id 唯一不能重复</label>
               </el-form-item>
             </div>


              <div class="input-group" >
               <el-form-item prop="cityName" >
                    <el-input type="text" id="cityName" v-model="city.cityName" class="input-field" placeholder=" " />
                     <label for="cityName" class="floating-label">城市名</label>
               </el-form-item>
             </div>


              <div class="input-group" >
               <el-form-item prop="parentId" >
                    <el-input type="text" id="parentId" v-model="city.parentId" class="input-field" placeholder=" " />
                     <label for="parentId" class="floating-label">父类城市Id</label>
               </el-form-item>
             </div>


              <div class="input-group" >
               <el-form-item prop="shortName" >
                    <el-input type="text" id="shortName" v-model="city.shortName" class="input-field" placeholder=" " />
                     <label for="shortName" class="floating-label">简写名称</label>
               </el-form-item>
             </div>


              <div class="input-group" >
               <el-form-item prop="areaCode" >
                    <el-input type="text" id="areaCode" v-model="city.areaCode" class="input-field" placeholder=" " />
                     <label for="areaCode" class="floating-label">城市代码</label>
               </el-form-item>
             </div>


              <div class="input-group" >
               <el-form-item prop="zipcode" >
                    <el-input type="text" id="zipcode" v-model="city.zipcode" class="input-field" placeholder=" " />
                     <label for="zipcode" class="floating-label">邮政编码</label>
               </el-form-item>
             </div>


              <div class="input-group" >
               <el-form-item prop="pinyin" >
                    <el-input type="text" id="pinyin" v-model="city.pinyin" class="input-field" placeholder=" " />
                     <label for="pinyin" class="floating-label">拼音</label>
               </el-form-item>
             </div>


              <div class="input-group" >
               <el-form-item prop="lng" >
                    <el-input type="text" id="lng" v-model="city.lng" class="input-field" placeholder=" " />
                     <label for="lng" class="floating-label">经度</label>
               </el-form-item>
             </div>


              <div class="input-group" >
               <el-form-item prop="lat" >
                    <el-input type="text" id="lat" v-model="city.lat" class="input-field" placeholder=" " />
                     <label for="lat" class="floating-label">纬度</label>
               </el-form-item>
             </div>


              <div class="input-group" >
               <el-form-item prop="level" >
                    <el-input type="text" id="level" v-model="city.level" class="input-field" placeholder=" " />
                     <label for="level" class="floating-label">城市级别</label>
               </el-form-item>
             </div>


              <div class="input-group" >
               <el-form-item prop="position" >
                    <el-input type="text" id="position" v-model="city.position" class="input-field" placeholder=" " />
                     <label for="position" class="floating-label">位置</label>
               </el-form-item>
             </div>


              <div class="input-group" >
               <el-form-item prop="sort" >
                    <el-input type="text" id="sort" v-model="city.sort" class="input-field" placeholder=" " />
                     <label for="sort" class="floating-label">排序</label>
               </el-form-item>
             </div>




              </el-form>


            </div>

            <!-- 固定的底部按钮区域 -->
            <div class="drawer-footer">
              <el-button type="primary" @click="save">保存</el-button>
            </div>
          </div>

        </el-drawer>
     </div>


  </template>

<script>



  var _this;
export default {
  name: 'Role',
  data () {
    return {
      tableHeight: 200,
      pageUtil:{total:0,pageSize:20,curPage:1},
      tableData:[],
      levelOpt:[
         { value: 1, label: '省'},
         { value: 2, label: '市'},
         { value: 3, label: '区/县'},
         { value: 4, label: '街道/乡镇'}

      ],
      searchParam:{
          level: '',
          cityName: ''
      },
      isOpenDrawer:false,
      optBtnStatus:'',
      optBtnInfo:{},
      city:{"zipcode":"","areaCode":"","pinyin":"","cityName":"","lng":"","level":"","id":"","position":"","sort":"","shortName":"","parentId":"","lat":""},
      dialogVisible: false,
      uploadUrl:''

    }
  }, mounted(){

    //_this.initContentHeight(_this);
      _this.$com.initContentHeight(_this);
      _this.getPage();

  },created: function () {
      _this = this;

  },methods:{

     getPage(){

       try {

            var param = _this.searchParam;

            param['pageSize'] = _this.pageUtil.pageSize;
            param['curPager'] = _this.pageUtil.curPage;

            _this.$http.get('/back_bin/city/get_page', param,(response)=>{

            _this.pageUtil.total = response.data.countSum;
            _this.pageUtil.curPage = response.data.curPager;
            let list = response.data.list;
            if(list!=null && list.length > 0){

              for(let i=0;i<list.length;i++){

                let bean = list[i];
                bean.createTime = _this.$com.dateConvertTime(bean.createTime);
                bean.lastUpdateTime = _this.$com.dateConvertTime(bean.lastUpdateTime);

              }

            }

            _this.tableData = list;
             console.info('请求结果1:', response )
            if(response .status == 'success'){


            }

            });

          } catch (error) {
            console.error('请求失败:', error)
          }


        },nextClick:function(){

            _this.pageUtil.curPage = _this.pageUtil.curPage+1;
            _this.getPage();

        },prevClick:function(){

            _this.pageUtil.curPage = _this.pageUtil.curPage-1;
            _this.getPage();

        },handleSizeChange:function(val) {

            _this.pageUtil.pageSize = val;

        },handleCurrentChange:function(val) {

            _this.pageUtil.curPage = val;
            _this.getPage();

        },addOpenDrawer:function(){

          _this.optBtnStatus = 'add';
           _this.resetForm();
           _this.isOpenDrawer = true;

        },handleClose:function(){

          _this.isOpenDrawer = false;

        },save(){

            if(_this.optBtnStatus == 'add'){
              _this.add();
            }else if(_this.optBtnStatus == 'update'){
               _this.update();
            }

        },async add(){

           try {

              var param = _this.city;
               param.birthday = _this.$com.formatDate(param.birthday);
              const response = await _this.$http.syncPost('/back_bin/city/add', param);
              if(response.status == 'success'){

                  _this.isOpenDrawer = false;
                  _this.$message({
                    message: '新增成功!',
                    type: 'success'
                  });

                  _this.getPage();

              }
              console.info('请求结果1:', response )

            } catch (error) {
              console.error('请求失败:', error)
            }

        },async update(){

           try {

              var param = _this.city;
              const response = await _this.$http.syncPost('/back_bin/city/update', param);
              if(response.status == 'success'){

                  _this.isOpenDrawer = false;
                  _this.$message({
                    message: '修改成功!',
                    type: 'success'
                  });

                  _this.getPage();

              }
              console.info('请求结果1:', response )

            } catch (error) {
              console.error('请求失败:', error)
            }

        },async getId(row){

           try {
              _this.optBtnStatus = 'update';
              _this.resetForm();
              var param = {'keyId':row.id};

              const response = await _this.$http.syncGet('/back_bin/city/get_by_id', param);
              if(response.status == 'success'){

                  _this.isOpenDrawer = true;
                   let city = response.data;

                  _this.city = city;

              }
              console.info('请求结果1:', response )

            } catch (error) {
              console.error('请求失败:', error)
            }

        },resetForm(){

           _this.dialogVisible = false;
            // 2. 关闭预览对话框
            _this.dialogVisible = false;
          _this.city = {"zipcode":"","areaCode":"","pinyin":"","cityName":"","lng":"","level":"","id":"","position":"","sort":"","shortName":"","parentId":"","lat":""}

        }
  }
}
</script>





// WEBPACK FOOTER //
// src/components/City.vue